import { Component } from "react";

export default class GooglePicker extends Component {
    constructor(props) {
        super(props);
        this.picker = null;
        this.pickerApiLoaded = false;   // 🔴 Track readiness
        this.loadPicker = this.loadPicker.bind(this);
        this.onPickerApiLoad = this.onPickerApiLoad.bind(this);
        this.open = this.open.bind(this);
    }

    componentDidMount() {
        //console.log("[Picker] componentDidMount fired");
        if (!window.gapi) {
            const script = document.createElement("script");
            script.src = "https://apis.google.com/js/api.js";
            script.onload = () => {
                window.gapi.load("picker", this.onPickerApiLoad);
            };
            document.body.appendChild(script);
        } else {
            window.gapi.load("picker", this.onPickerApiLoad);
        }
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.token !== prevProps.token ||
            this.props.view !== prevProps.view
        ) {
            //console.log("[Picker] Props changed, attempting to load picker...");
            this.loadPicker();
        }
    }

    onPickerApiLoad() {
        //console.log("[Picker] Picker API loaded");
        this.pickerApiLoaded = true;
        this.loadPicker();
    }

    loadPicker() {
        const { token, apiKey, view, appId  } = this.props;
        //console.log("[Picker] loadPicker called with:", {
        //    token: this.props.token,
        //    apiKey: this.props.apiKey,
        //    view: this.props.view
        //});
        if (!this.pickerApiLoaded) {
            //console.log("[Picker] API not ready yet");
            return;
        }

        if (!window.google || !window.google.picker) {
            //console.warn("[Picker] google.picker not available yet");
            return;
        }

        if (!token || !apiKey || !view) {
            //console.log("[Picker] Missing token/apiKey/view", { token, apiKey, view });
            return;
        }

        // Prevent rebuilding multiple times
        if (this.picker) {
            //console.log("[Picker] Picker already built, opening...");
            this.open();
            return;
        }

        //console.log("[Picker] Building picker...");

        // --- Build views ---
        const docsView = new window.google.picker.DocsView(window.google.picker.ViewId.DOCS)
            .setMimeTypes("application/vnd.google-apps.document")
            .setIncludeFolders(false);

        const sheetsView = new window.google.picker.DocsView(window.google.picker.ViewId.SPREADSHEETS)
            .setMimeTypes("application/vnd.google-apps.spreadsheet")
            .setIncludeFolders(false);

        const slidesView = new window.google.picker.DocsView(window.google.picker.ViewId.PRESENTATIONS)
            .setMimeTypes("application/vnd.google-apps.presentation")
            .setIncludeFolders(false);
        
        const viewMap = {
            "application/vnd.google-apps.document": docsView,
            "application/vnd.google-apps.spreadsheet": sheetsView,
            "application/vnd.google-apps.presentation": slidesView
        };

        const orderedViews = [];
        if (viewMap[view]) orderedViews.push(viewMap[view]);
        Object.values(viewMap).forEach(v => {
            if (!orderedViews.includes(v)) orderedViews.push(v);
        });

        const picker = new window.google.picker.PickerBuilder()
            .setOAuthToken(token)
            .setDeveloperKey(apiKey)
            .setAppId(appId)
            .setCallback((data) => {
                if (data.action === window.google.picker.Action.PICKED) {
                    if (this.props.onPicked) this.props.onPicked(data.docs);
                }

                if (data.action === window.google.picker.Action.CANCEL) {
                    if (this.props.onCancel) this.props.onCancel();
                }
            })
            .enableFeature(window.google.picker.Feature.MULTISELECT_ENABLED);

        orderedViews.forEach(v => picker.addView(v));

        this.picker = picker.build();
        this.open();
    }

    open() {
        if (this.picker) {
            //console.log("[Picker] Opening picker");
            this.picker.setVisible(true);
        }
    }

    render() {
        return null;
    }
}
